
import React from "react";
import { TableRow, TableCell } from "@/components/ui/table";

interface CampaignEmptyStateProps {
  status: "draft" | "active" | "scheduled" | "completed";
}

const CampaignEmptyState = ({ status }: CampaignEmptyStateProps) => {
  const getEmptyStateMessage = () => {
    switch (status) {
      case "active":
        return {
          title: "Nenhuma campanha ativa",
          description: "Campanhas aparecerão aqui quando estiverem neste status"
        };
      case "scheduled":
        return {
          title: "Nenhuma campanha agendada",
          description: "Campanhas aparecerão aqui quando estiverem neste status"
        };
      case "completed":
        return {
          title: "Nenhuma campanha finalizada",
          description: "Campanhas aparecerão aqui quando estiverem neste status"
        };
      case "draft":
        return {
          title: "Nenhuma campanha em rascunho",
          description: "Crie sua primeira campanha clicando no botão 'Nova Campanha'"
        };
      default:
        return {
          title: "Nenhuma campanha encontrada",
          description: "Campanhas aparecerão aqui quando estiverem disponíveis"
        };
    }
  };

  const { title, description } = getEmptyStateMessage();

  return (
    <TableRow>
      <TableCell colSpan={6} className="text-center py-12 text-gray-500">
        <div className="space-y-2">
          <div className="text-lg font-medium">{title}</div>
          <div className="text-sm">{description}</div>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default CampaignEmptyState;
